import { render, staticRenderFns } from "./ActivityGoods.vue?vue&type=template&id=4f9d3a70&scoped=true"
import script from "./ActivityGoods.vue?vue&type=script&lang=js"
export * from "./ActivityGoods.vue?vue&type=script&lang=js"
import style0 from "./ActivityGoods.vue?vue&type=style&index=0&id=4f9d3a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d3a70",
  null
  
)

export default component.exports